<div
	fxLayout="column"
	class="mat-mdc-menu-panel"
	class="w-100"
	fxFlex="100%"
	fxFill="100%"
>
	<a
		i18n="@@header_label_animalRescue"
		[href]="animalRescueHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Animal Rescue</a
	>
	<a
		i18n="@@header_label_charityFundraising"
		[href]="charityFundraisingHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Charity Fundraising</a
	>
	<a
		i18n="@@header_label_climateCrisis"
		[href]="climateCrisisHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Climate Crisis</a
	>
	<a
		i18n="@@header_label_coronavirusReliefFund"
		[href]="coronavirusReliefFundHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Coronavirus Relief Fund</a
	>
	<a
		i18n="@@header_label_corporateGiving"
		[href]="corporateGivingHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Corporate Giving</a
	>
	<a
		i18n="@@header_label_dendriticCellTherapy"
		[href]="dendriticCellTherapyHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Dendritic Cell Therapy</a
	>
	<a
		i18n="@@header_label_domesticViolence"
		[href]="domesticViolenceHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Domestic Violence</a
	>
	<a
		i18n="@@header_label_energyCrisis"
		[href]="energyCrisisHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Energy Crisis</a
	>
	<a
		i18n="@@header_label_financialAid"
		[href]="financialAidHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Financial Aid</a
	>
	<a
		i18n="@@header_label_fireEmergency"
		[href]="fireEmergencyHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Fire Emergency</a
	>
	<a
		i18n="@@header_label_fundraisingForEducation"
		[href]="fundraisingForEducationHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Education</a
	>
	<a
		i18n="@@header_label_fundraisingForFuneral"
		[href]="fundraisingForFuneralHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Funeral</a
	>
	<a
		i18n="@@header_label_fundraisingForNonprofit"
		[href]="fundraisingForNonprofitsHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Nonprofits</a
	>
	<a
		i18n="@@header_label_legalServices"
		[href]="legalServicesHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Legal Services</a
	>
	<a
		i18n="@@header_label_lgbtqCommunity"
		[href]="lgbtqCommunityHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for LGBTQ Community</a
	>
	<a
		i18n="@@header_label_medicalFundraising"
		[href]="medicalHref"
		mat-menu-item
		class="hover-class"
		>Medical Fundraising</a
	>
	<a
		i18n="@@header_label_msHsct"
		[href]="msHsctHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for MS HSCT</a
	>
	<a
		i18n="@@header_label_musicFundraising"
		[href]="musicHref"
		mat-menu-item
		class="hover-class"
		>Music Fundraising</a
	>
	<a
		i18n="@@header_label_muslimCharity"
		[href]="muslimCharityHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Muslim Charity</a
	>
	<a
		i18n="@@header_label_onc201"
		[href]="onc201Href"
		mat-menu-item
		class="hover-class"
		>Fundraiser for ONC201</a
	>
	<a
		i18n="@@header_label_personalFundraising"
		[href]="personalFundraisingHref"
		mat-menu-item
		class="hover-class"
		>Personal Fundraising</a
	>
	<a
		i18n="@@header_label_serviceDog"
		[href]="serviceDogHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Service Dog</a
	>
	<a
		i18n="@@header_label_smaZiekte"
		[href]="smaDiseaseHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for SMA Disease</a
	>
	<a
		i18n="@@header_label_sportsFundraising"
		[href]="sportsFundraisingHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Sports Fundraising</a
	>
	<a
		i18n="@@header_label_supportUkraine"
		[href]="supportUkraineHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Support Ukraine</a
	>
	<a
		i18n="@@header_label_surrogacy"
		[href]="surrogacyFundraiserHref"
		mat-menu-item
		class="hover-class"
		>Surrogacy Fundraiser</a
	>
	<a
		i18n="@@header_label_travelExpenses"
		[href]="travelExpensesHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Travel Expenses</a
	>
	<a
		i18n="@@header_label_waterDamage"
		[href]="waterDamageHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Water Damage</a
	>
	<a
		i18n="@@header_label_wheelchairBus"
		[href]="wheelchairFundraisingHref"
		mat-menu-item
		class="hover-class"
		>Fundraiser for Wheelchair Fundraising</a
	>
</div>
